var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphonesCustomerSupportQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.99997C9.99876 6.44184 11.1905 5.14212 12.7429 5.00861C14.2953 4.8751 15.6915 5.95224 15.9564 7.4877C16.2212 9.02317 15.2664 10.5058 13.759 10.9C13.3243 10.9952 13.0109 11.3751 13 11.82V13.5",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5C13.1381 15.5 13.25 15.6119 13.25 15.75C13.25 15.8881 13.1381 16 13 16C12.8619 16 12.75 15.8881 12.75 15.75C12.75 15.6119 12.8619 15.5 13 15.5",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.5H18C19.934 21.5 21.5 20.433 21.5 18.5V16.33",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 8.5C22.4491 8.49862 24.1155 9.90231 24.4452 11.8233C24.7749 13.7444 23.672 15.6234 21.834 16.272C21.528 16.3804 21.1884 16.3336 20.9232 16.1463C20.658 15.959 20.5002 15.6547 20.5 15.33L20.5 8.5Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49979 8.5C3.55068 8.49862 1.88434 9.90231 1.55461 11.8233C1.22488 13.7444 2.32778 15.6234 4.16579 16.272C4.4718 16.3804 4.81142 16.3336 5.07662 16.1463C5.34182 15.959 5.4996 15.6547 5.49979 15.33V8.5Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10V8C20.5 3.85786 17.1421 0.5 13 0.5C8.85786 0.5 5.5 3.85786 5.5 8V10",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 20.5H16.5C16.7761 20.5 17 20.7239 17 21V22C17 22.2761 16.7761 22.5 16.5 22.5H12.5C11.9477 22.5 11.5 22.0523 11.5 21.5V21.5C11.5 20.9477 11.9477 20.5 12.5 20.5Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesCustomerSupportQuestion);
export default __webpack_public_path__ + "static/media/headphones-customer-support-question.f8e83f60b6acda24678d7b5f3b58af0b.svg";
export { ForwardRef as ReactComponent };